import { render, staticRenderFns } from "./RegulationsBaseHeaderSec.vue?vue&type=template&id=5080b2a5&scoped=true&"
import script from "./RegulationsBaseHeaderSec.vue?vue&type=script&lang=js&"
export * from "./RegulationsBaseHeaderSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080b2a5",
  null
  
)

export default component.exports